import { React, useState, useRef } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@mui/material";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    button: {
        "&.active": {
            background: "black",
        },
    },
});

export default function MakePayment(gotoScreen = "", customerFields = {}) {
    let totalBalanceButton = useRef();
    let minPaymentButton = useRef();

    let paymentAmount = 0;
    const handleChange = (event, nextView) => {
        console.log("paying " + nextView);
        if (nextView == "minimum") {
            paymentAmount = customerFields.loanloan_amount_due;
        } else {
            paymentAmount = customerFields.loan_balance;
        }
    };

    const processPayment = (e) => {
        if (paymentAmount > 0) {
            console.log("PAID", paymentAmount);
            gotoScreen("paymentReceived", paymentAmount);
        } else {
            alert("Payment amount is required");
        }
    };

    const setActive = (e) => {
        switch (e) {
            case "totalBalanceButton":
                totalBalanceButton.current.style.borderColor = "#000000";
                minPaymentButton.current.style.borderColor = "#FFFFFF";
                break;
            case "minPaymentButton":
                totalBalanceButton.current.style.borderColor = "#FFFFFF";
                minPaymentButton.current.style.borderColor = "#000000";
                break;
        }
    };

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    return (
        <>
            <h4>Make a Payment</h4>
            <div className="headerRow">Please select a payment amount below and press Process Payment.</div>
            <br />
            <ToggleButtonGroup name="paymentAmount" orientation="vertical" exclusive onChange={handleChange} fullWidth>
                <ToggleButton className="paymentButton" value="total" aria-label="total" style={{ textTransform: "none" }} fullWidth onClick={(e) => setActive("totalBalanceButton")} ref={totalBalanceButton}>
                    <Grid container sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Grid item>Total Balance Due</Grid>
                        <Grid item justifyContent="flex-end">
                            <b>{formatter.format(customerFields.loan_balance)}</b>
                        </Grid>
                    </Grid>
                </ToggleButton>
                <ToggleButton className="paymentButton" value="mimimum" aria-label="total" style={{ textTransform: "none" }} fullWidth onClick={(e) => setActive("minPaymentButton")} ref={minPaymentButton}>
                    <Grid container sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Grid item>Mimimum Payment Due</Grid>
                        <Grid item justifyContent="flex-end">
                            <b>{formatter.format(customerFields.loan_amount_due)}</b>
                        </Grid>
                    </Grid>
                </ToggleButton>
            </ToggleButtonGroup>
            <br />
            <br />
            <Button variant="contained" disableElevation fullWidth onClick={(e) => processPayment(e)}>
                Process Payment
            </Button>
        </>
    );
}
